module.exports = __webpack_public_path__ + "img/title.aead4749.jpg";